/* Cartec Essentials — scoped brand JS
   Scroll-reveal via IntersectionObserver. Theme-editor-aware:
   in de editor tonen we alles direct (geen verborgen content). */
(function () {
  var observer = null;

  function revealAll(root) {
    (root || document).querySelectorAll('.ce-reveal').forEach(function (el) {
      el.classList.add('ce-in');
    });
  }

  // Neemt zowel bestaande als later toegevoegde elementen in behandeling.
  // Zonder deze functie blijft alles wat ná het laden in de DOM komt
  // (cross-sell, aanbevelingen, secties uit de Section Rendering API)
  // op opacity:0 staan en is het dus onzichtbaar.
  function scan(root) {
    if (!observer) {
      revealAll(root);
      return;
    }
    var node = root || document;
    if (node.nodeType === 1 && node.classList && node.classList.contains('ce-reveal')) {
      observer.observe(node);
    }
    if (node.querySelectorAll) {
      node.querySelectorAll('.ce-reveal:not(.ce-in)').forEach(function (el) {
        observer.observe(el);
      });
    }
  }

  function init() {
    var prefersReduced =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var inEditor = window.Shopify && window.Shopify.designMode;

    if (!prefersReduced && !inEditor && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('ce-in');
              observer.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
      );
    }

    scan();

    // Later geïnjecteerde content alsnog laten verschijnen.
    if ('MutationObserver' in window) {
      new MutationObserver(function (mutations) {
        for (var m = 0; m < mutations.length; m++) {
          var added = mutations[m].addedNodes;
          for (var n = 0; n < added.length; n++) {
            if (added[n].nodeType === 1) scan(added[n]);
          }
        }
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-scan wanneer een sectie in de theme-editor opnieuw wordt geladen
  document.addEventListener('shopify:section:load', function () {
    revealAll();
  });
})();

/* Succes-feedback op de eigen productkaart-knoppen ("In winkelmand" / "+").
   Deze knoppen doen de toevoeging via de native product-form-component (AJAX),
   maar hebben niet de vinkje-animatie van de native add-to-cart-knop. We tonen
   hier kort een groen vinkje op de knop zelf, net als de hoofd-CTA. Optimistisch
   op submit (gelijk aan het native gedrag), daarna vanzelf terug. */
(function () {
  var RESET_MS = 1400;
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('ce-card__form')) return;
    var btn = form.querySelector('.ce-card__cta, .ce-card__add');
    if (!btn || btn.classList.contains('is-added')) return;
    btn.classList.add('is-added');
    setTimeout(function () { btn.classList.remove('is-added'); }, RESET_MS);
  });
})();
